<template>
  <sui-modal class="wrapper" size="small" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Update role
    </sui-modal-header>
    <sui-modal-content>
      <sui-form :error="hasApiErrors" :loading="loading" v-if="entity" @submit.prevent="submit()">
        <FormRole v-model="entity" :mode="mode" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button class="left floated basic red" icon="trash" :disabled="!access.accManagement" label-position="left" @click="deleteRole()">
        Delete
      </sui-button>
      <sui-button-group>
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors || !hasChanges || !access.accManagement" data-goal="UPDATE_ROLE_TRY" @click="submit()">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </sui-button-group>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  import ModalForm from '@/mixins/ModalForm'
  import FormRole from '@/components/forms/Role'
  import utils from '@/utils'

  export default {
    name: 'ModalUpdateRole',
    mixins: [
      ModalForm,
    ],
    components: {
      FormRole,
    },
    data() {
      return {
        accountId: null,
      }
    },
    computed: {
      ...mapGetters(['access', 'account']),
      mode() {
        return 'updating'
      },
    },
    methods: {
      open(entity) {
        this.visible = true
        this.entity = cloneDeep(entity)
      },
      onSuccess() {
        this.close()
        utils.reachGoal('UPDATE_ROLE_SUCCESS')
      },
      onFail() {
        utils.reachGoal('UPDATE_ROLE_FAIL')
      },
      deleteRole() {
        return this.$modals.confirm.open({
          text: `<p>You are going to delete <b>${this.entity.name}</b> role.</p>`,
          callback: () => {
            this.apiErrors = null
            utils.reachGoal('UPDATE_ROLE_DELETE_TRY')
            this.entity.delete().then(() => {
              utils.reachGoal('UPDATE_ROLE_DELETE_SUCCESS')
              this.close()
            }).catch(error => {
              utils.reachGoal('UPDATE_ROLE_DELETE_FAIL')
              this.apiErrors = error
            })
          },
        })
      },
    },
    created() {
      this.$modals.updateRole = this
    },
  }
</script>
